import {
    FETCH_BLOG_POSTS_SUCCESS,
    FETCH_BLOG_POST_SUCCESS,
    UPDATE_BLOG_POST_SUCCESS,
    FETCH_BLOG_POSTS_FAIL,
    FETCH_BLOG_POST_FAIL,
    UPDATE_BLOG_POST_FAIL,
    CLEAR_SELECTED_POST,
    CLEAR_ERROR,
    FETCH_BLOG_TITLES_SUCCESS,
    FETCH_BLOG_TITLES_FAIL,
    UPDATE_BLOG_TITLE_SUCCESS,
    UPDATE_BLOG_TITLE_FAIL,
} from "../actions/admin";

const initialState = {
    posts: [],
    selectedPost: null,
    blogTitles: [],
    isLoading: false,
    error: null,
};

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BLOG_POSTS_SUCCESS:
            return {
                ...state,
                posts: action.payload,
                isLoading: false,
                error: null,
            };
        case FETCH_BLOG_POST_SUCCESS:
            return {
                ...state,
                selectedPost: action.payload,
                isLoading: false,
                error: null,
            };
        case UPDATE_BLOG_POST_SUCCESS:
            return {
                ...state,
                selectedPost: action.payload,
                isLoading: false,
                error: null,
            };
        case FETCH_BLOG_POSTS_FAIL:
        case FETCH_BLOG_POST_FAIL:
        case UPDATE_BLOG_POST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_SELECTED_POST:
            return {
                ...state,
                selectedPost: null,
            };
        case CLEAR_ERROR:
            return {
                ...state,
                error: null,
            };
        case FETCH_BLOG_TITLES_SUCCESS:
            return {
                ...state,
                blogTitles: action.payload,
                isLoading: false,
                error: null,
            };
        case UPDATE_BLOG_TITLE_SUCCESS:
            return {
                ...state,
                blogTitles: state.blogTitles.map((title) =>
                    title.id === action.payload.id
                        ? { ...title, status: action.payload.status }
                        : title
                ),
                isLoading: false,
                error: null,
            };
        case FETCH_BLOG_TITLES_FAIL:
        case UPDATE_BLOG_TITLE_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default adminReducer;
